import { render, staticRenderFns } from "./LevelSelect.vue?vue&type=template&id=968a7ac2"
import script from "./LevelSelect.ts?vue&type=script&lang=ts&external"
export * from "./LevelSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./LevelSelect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports